export var E_SPACE_LINE_HIGHT_TYPE;
(function (E_SPACE_LINE_HIGHT_TYPE) {
    E_SPACE_LINE_HIGHT_TYPE["AUTO"] = "auto";
    E_SPACE_LINE_HIGHT_TYPE["LOW"] = "low";
    E_SPACE_LINE_HIGHT_TYPE["MIDDLE"] = "middle";
    E_SPACE_LINE_HIGHT_TYPE["HIGH"] = "high";
})(E_SPACE_LINE_HIGHT_TYPE || (E_SPACE_LINE_HIGHT_TYPE = {}));
export var E_SPACE_TEXT_LANGUAGE;
(function (E_SPACE_TEXT_LANGUAGE) {
    E_SPACE_TEXT_LANGUAGE["DEFAULT"] = "default";
    E_SPACE_TEXT_LANGUAGE["CN"] = "translation_cn";
    E_SPACE_TEXT_LANGUAGE["EN"] = "translation_en";
    E_SPACE_TEXT_LANGUAGE["JP"] = "translation_jp";
})(E_SPACE_TEXT_LANGUAGE || (E_SPACE_TEXT_LANGUAGE = {}));
export var E_SPACE_TYPE;
(function (E_SPACE_TYPE) {
    E_SPACE_TYPE["MY"] = "personal-workspaces";
    E_SPACE_TYPE["NAVIGATION"] = "navigation";
    E_SPACE_TYPE["SHARED"] = "shared-workspaces";
    E_SPACE_TYPE["PUBLIC"] = "public-workspaces";
    E_SPACE_TYPE["UNKNOWN"] = "unknown";
})(E_SPACE_TYPE || (E_SPACE_TYPE = {}));
export var E_SPACE_USER_ROLE;
(function (E_SPACE_USER_ROLE) {
    E_SPACE_USER_ROLE["OWNER"] = "OWNER";
})(E_SPACE_USER_ROLE || (E_SPACE_USER_ROLE = {}));
// /**
//  * 数据源类型
//  */
// export enum DataType {
//     PATENT ='patent',
//     PAPER = 'paper',
//     BIO = 'bio',
//     DRUG = 'drug',
//     CLINICAL = 'clinical',
//     MARKET = 'market',
//     INVESTMENT = 'investment',
//     MERGER = 'merger'
// }
// /**
//  * 视图类型
//  */
// export enum ViewType {
//     TABLE = 'table',
//     STANDARD = 'standard',
//     FULL_IMAGE = 'full_image',
//     THUMB = 'thumbnail',
//     FAST_TABLE = 'fast_table',
//     WORD_CLOUD = 'word_cloud'
// }
